export default {
  name: "FallbackPictureCopyrightEditView",
  props: ["apiKey", "disabled"],
  data: () => ({
    dialog: false
  })
};
